
import React from "react";
import { Button } from "@/components/ui/button";
import { ClipboardList, FileText } from "lucide-react";

export default function CTASection() {
  // Find the main nursing home guide slug - in a real app this would likely come from a CMS or config
  const mainGuideSlug = "finding-a-nursing-home-in-ireland";

  return <section className="py-20 bg-grandpal-green-dark text-white">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6">
            Need help finding the right nursing home?
          </h2>
          <p className="text-xl mb-8 text-grandpal-green-light">
            Our team is here to guide you through every step of the process, from understanding your options to making the final decision.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button size="lg" className="bg-white text-grandpal-green-dark hover:bg-grandpal-beige" asChild>
              <a href="/nursing-homes">
                <ClipboardList className="mr-2 h-5 w-5" />
                Explore Homes
              </a>
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10 bg-grandpal-green-dark border-2" asChild>
              <a href={`/guides/${mainGuideSlug}?openDownloadModal=true`}>
                <FileText className="mr-2 h-5 w-5" />
                Download Guide
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}
